// src/components/LoadingScreen.tsx
import { useEffect, useRef } from "react";
import gsap from "gsap";
import logo from "../logoWhite.svg";

export default function LoadingScreen({ done }: { done: boolean }) {

    const loaderRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!done) return;

        gsap.to(loaderRef.current, {
            y: -1500,              // move UP
            opacity: 1,
            duration: 4,
            ease: "power3.out",
        });

    }, [done]);

    return (
        <div
            ref={loaderRef}
            className="loading-screen fixed inset-0 flex flex-col items-center justify-center bg-[#201647] text-white z-50"
        >
            <img src={logo} alt="Loading Logo" className="app-logo w-24 h-24 mb-6" />
            <div className="w-48 h-1 bg-gray-700 relative overflow-hidden rounded-full">
                <div className="absolute inset-y-0 left-0 w-1/3 bg-white animate-[pulse_1.2s_infinite]" />
            </div>
        </div>
    );
}
